import { gql } from '@apollo/client';

export const INSTANT_REVIEW_PHONE_MUTATION = gql`
    mutation instantReviewPhone($input: InstantReviewPhoneInput!) {
        instantReviewPhone (input: $input)
    }
`